import LiteLocationOnboardingDialog from './LiteLocationOnboardingDialog';

export default LiteLocationOnboardingDialog;
